const PC_MQ = "(min-width: 769px)";

function linkNeedsStack(link) {
  const text = link.querySelector(".mindRelatedLink__text");
  const enWrap = link.querySelector(".mindRelatedLink__enWrap");
  const ja = link.querySelector(".mindRelatedLink__ja");
  if (!text || !enWrap || !ja) return false;

  const gap = parseFloat(getComputedStyle(text).columnGap) || 0;
  return enWrap.offsetWidth + gap + ja.offsetWidth > text.clientWidth + 1;
}

function updateList(list, isPc) {
  if (!isPc) {
    list.classList.remove("is-stacked");
    return;
  }

  // 横並び前提で計測（縦積み中は JA の padding や gap が変わるため）
  list.classList.remove("is-stacked");

  const needsStack = [...list.querySelectorAll(".mindRelatedLink")].some(
    linkNeedsStack
  );
  list.classList.toggle("is-stacked", needsStack);
}

export function initMindRelatedStack() {
  const lists = [...document.querySelectorAll(".mindRelated__list")];
  if (!lists.length) return;

  const mq = window.matchMedia(PC_MQ);
  let rafId = 0;

  const update = () => {
    const isPc = mq.matches;
    lists.forEach((list) => updateList(list, isPc));
  };

  const schedule = () => {
    cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(update);
  };

  update();
  if (document.fonts?.ready) {
    document.fonts.ready.then(schedule);
  }

  mq.addEventListener("change", schedule);
  window.addEventListener("resize", schedule);

  // 高さ変化（is-stacked 切替）では再計測しない → ループ防止
  if (typeof ResizeObserver !== "undefined") {
    lists.forEach((list) => {
      let lastWidth = list.getBoundingClientRect().width;
      const ro = new ResizeObserver((entries) => {
        const width = entries[0]?.contentRect?.width;
        if (width == null || Math.abs(width - lastWidth) < 1) return;
        lastWidth = width;
        schedule();
      });
      ro.observe(list);
    });
  }
}
